 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"auth-auth-module":"auth-auth-module","coins-coins-module":"coins-coins-module","common":"common","chat-chat-module":"chat-chat-module","logs-logs-module":"logs-logs-module","default~dynamic-info-dynamic-info-module~sleep-information-sleep-information-module":"default~dynamic-info-dynamic-info-module~sleep-information-sleep-information-module","dynamic-info-dynamic-info-module":"dynamic-info-dynamic-info-module","sleep-information-sleep-information-module":"sleep-information-sleep-information-module","history-history-module":"history-history-module","notifications-notifications-module":"notifications-notifications-module","polyfills-core-js":"polyfills-core-js","polyfills-css-shim":"polyfills-css-shim","polyfills-dom":"polyfills-dom","report-bug-report-bug-module":"report-bug-report-bug-module","shadow-css-a3f00b33-js":"shadow-css-a3f00b33-js","stats-stats-module":"stats-stats-module","web":"web","swiper-bundle-6c5e7804-js":"swiper-bundle-6c5e7804-js","focus-visible-f4ad4f1a-js":"focus-visible-f4ad4f1a-js","input-shims-ce03ee9f-js":"input-shims-ce03ee9f-js","keyboard-5742b5da-js":"keyboard-5742b5da-js","status-tap-9cb487b1-js":"status-tap-9cb487b1-js","swipe-back-1bbd08e0-js":"swipe-back-1bbd08e0-js","tap-click-7ddcdebb-js":"tap-click-7ddcdebb-js"}[chunkId]||chunkId) + "-es2015." + {"0":"f5bec8328272b9d47e67","1":"968216da1a89bbd450a1","2":"6ff2b4f0b5edcd74b14f","3":"d42c623c44de05750b23","4":"782cf0f45fd67ee6ad90","5":"a0e24d856e5ec0bfe560","6":"41c161eeec42867f22a6","7":"438537e5544c71ff308d","8":"9bea40e9ac79f25d4149","9":"03307826a16ad8efc3c9","10":"6d9d46debebcee346081","11":"6584d547733f96eebdb5","12":"98ef6a286e2bde5b2e75","13":"6a1ba89212a91f16861a","14":"2c29328761c827bcd854","15":"506acea7b9dc436bb819","16":"482d0ab9f4a23570e3a5","17":"cc933ba8eaa81f3ab3a3","18":"bd848926e072a7ee6d49","19":"636e181782171207ae51","20":"6548f0f1982850f6bfcf","21":"04668082b0f57423a69d","22":"7bbca558cb610a7cdfaa","23":"7195fd06aacfb69bda02","24":"214d861f0cee0500f75f","25":"07f34e8707f182c8e955","26":"0b8010f8db133d401d6c","27":"44eec0797f456ce9d674","28":"4796203bac9b5aff02ac","29":"9089ca7e9303fa7341e4","30":"e67c51aec66299aeda6a","31":"b69445ae79fbf3f62b4f","32":"14326fbdd94f3aa6b688","33":"d9d5964aebd9cefca54a","34":"7f733425fcbf297fdaf1","35":"13a62da4686b4f578106","36":"61479a8a7ef0fbe5e767","37":"c17bf4e28c3880d89b54","38":"5892420f4b701efd1b6a","39":"70e82f8b2528b904f9dc","40":"a8535230a83e25ca114e","41":"ccabcdd8e54e62c40ead","42":"f33bdf2ff9ab18620549","auth-auth-module":"f21142e2aef0ece4dccd","coins-coins-module":"8879ea343e7b1669b85f","common":"ceb2976952df902742b7","chat-chat-module":"82b2d7386be71533d380","logs-logs-module":"bf482ef8da01d47429c6","default~dynamic-info-dynamic-info-module~sleep-information-sleep-information-module":"464fbbcd07e16c8ff06e","dynamic-info-dynamic-info-module":"f14990d93e31f4049529","sleep-information-sleep-information-module":"33a834f6ec6a3b4d7d34","history-history-module":"336f3f5a3a3febde4c7a","notifications-notifications-module":"b2f698f97fb6f14e6679","polyfills-core-js":"a0f10ad50a0537e5738a","polyfills-css-shim":"8ff2d6a234453d602d30","polyfills-dom":"a5c28f24fc6778e058c3","report-bug-report-bug-module":"d6fef991027505adcbcd","shadow-css-a3f00b33-js":"36e8d19d04bc13925274","stats-stats-module":"dd0098d2f0c4671a7548","web":"84ce4981461ac9f18758","swiper-bundle-6c5e7804-js":"20043e215232cc15ae3d","focus-visible-f4ad4f1a-js":"95aa92123f623eefc8a1","input-shims-ce03ee9f-js":"fd97516a91c4c1f49e5e","keyboard-5742b5da-js":"6ae0bbf13d8a582554d0","status-tap-9cb487b1-js":"54df5d5cf0c920649c3e","swipe-back-1bbd08e0-js":"9b5f07d402995641661c","tap-click-7ddcdebb-js":"c7babcd983381cc258d1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
